module.exports = __webpack_public_path__ + "static/media/d24kz.4593cc41.pdf";